import { render } from "./JobEdit.vue?vue&type=template&id=32f688bc"
import script from "./JobEdit.vue?vue&type=script&lang=js"
export * from "./JobEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__